import { ClienteAnaliseMercadoRAPSaveMesRequest } from './cliente-analise-mercado-rap-save-mes.request';

/** Request com os dados para salvar uma Análise de Mercado RAP */
export class ClienteAnaliseMercadoRAPSaveRequest {
    idCliente: number;
    ano: number;
    periodicidade: number;
    valorPotencial: number;
    valorPretendido: number;
    meses: ClienteAnaliseMercadoRAPSaveMesRequest[];
    anotacao: string;

    constructor(props: Partial<ClienteAnaliseMercadoRAPSaveRequest>) {
        Object.assign(this, props);

        // Meses
        if (props.meses) {
            for (let i = 0; i < props.meses.length; i++) {
                const mes = new ClienteAnaliseMercadoRAPSaveMesRequest(props.meses[i]);
                props.meses[i] = mes;
            }
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objeto criado
     */
    static fromJSON(json: string): ClienteAnaliseMercadoRAPSaveRequest {
        return new ClienteAnaliseMercadoRAPSaveRequest(JSON.parse(json));
    }
}
